/*重构的模型训练的接口功能*/
import axios from "../index";
// import qs from "qs";
import api from "./pretrain.api";

export default {
  // 我的模型
  /**
   * 查询训练模型版本信息  @data "curriculumId":课程id,trainingId实训id，"pageNum" 当前页数;  "pageSize"每页条数
   */
  getTrainModelByModelId(data = {}) {
    return axios.post(api.getTrainModelByModelId, data);
  },
  /**
   * 查询当前账号下我的模型列表  @data "modelName":模型名称 ;type 模型类型;"pageNum" ;  "pageSize"
   */
  getMyModelList(data = {}) {
    return axios.post(api.getMyModelList, data);
  },
  /**
   * 查询模型类型  @data
   */
  getModelType() {
    return axios.post(api.getModelType);
  },
  /**
   * 查询模型数据下拉框  @data
   */
  getModelData(data = {}) {
    return axios.post(api.getModelData, data);
  },
  /**
   * 创建模型  @data modelFuncDesc模型功能描述 modelName模型名称  type模型类型int
   */
  addModel(data = {}) {
    return axios.post(api.addModel, data);
  },
  /**
   * 修改模型  @data modelFuncDesc模型功能描述 modelName模型名称  modelId模型id
   */
  updateModel(data = {}) {
    return axios.post(api.updateModel, data);
  },
  /**
   * 删除模型  @data modelFuncDesc模型功能描述 modelName模型名称  modelId模型id
   */
  deleteModel(data = {}) {
    return axios.post(api.deleteModel, data);
  },
  /**
   * 删除模型  @data trainModelId 等价于 modelId
   */
  deleteTrainingModel(data = {}) {
    return axios.post(api.deleteTrainingModel, data);
  },
  /**
   * 获取模型报告  @data {trainModelId: "训练模型id", type: "类型：1为图像分类;2为物体检测;"}
   */
  getAssessmentReport(data = {}) {
    return axios.post(api.getAssessmentReport, data);
  },


  // 数据集中心接口
  /**
   * 创建数据集  @data datasetContent数据集简介 datasetName数据集名称  type数据集类型
   */
  addDataset(data = {}) {
    return axios.post(api.addDataset, data);
  },
  /**
   * 查询当前账号下我的数据集列表  @data  "datasetName"数据集名称；"type"类型； pageNum当前页数  pageSize每页条数
   */
  getMyDatasetList(data = {}) {
    return axios.post(api.getMyDatasetList, data);
  },
  /**
   * 查询数据集版本列表  @data  "datasetName"数据集名称；"type"类型； pageNum当前页数  pageSize每页条数
   */
   getMyDatasetVersionList(data = {}) {
    return axios.post(api.getMyDatasetVersionList, data);
  },

  /**
   * 分类/标注查询当前数据集列表  @data  tenantId："租户id", type: 类型
   */
   selectDataset(data = {}) {
    return axios.post(api.selectDataset, data);
  },
  /**
   * 分类/选择数据集版本下拉框接口  @data  tenantId："租户id", type: 类型
   */
   selectDatasetVersion(data = {}) {
    return axios.post(api.selectDatasetVersion, data);
  },
  /**
   * 选择数据集已发布版本下拉框接口  @data  tenantId："租户id", type: 类型
   */
   selectDatasetReleaseVersion(data = {}) {
    return axios.post(api.selectDatasetReleaseVersion, data);
  },
  /**
   * 根据数据集id查询 图像筛选设置的参数  @data  "datasetId"数据集id；behaviorType：类型1为获取图片筛选宽高大小的参数
   */
  getBehaviorByDatasetId(data = {}) {
    return axios.post(api.getBehaviorByDatasetId, data);
  },
  /**
   * 根据数据集id查询标签 标签分类(无返回每个标签分类数量)  @data  "datasetId"数据集id； labelName：标签名称（需要进行模糊搜索则传）； modelType：模型类型（1为图像分类；2为物体检测；3文本分类；4文本标注）
   */
  getLabelByDatasetId(data = {}) {
    return axios.post(api.getLabelByDatasetId, data);
  },
  /**
   * 根据数据集id查询标签 标签分类(有返回每个标签分类数量)  @data  "datasetId"数据集id； labelName：标签名称（需要进行模糊搜索则传）； modelType：模型类型（1为图像分类；2为物体检测；3文本分类；4文本标注）
   */
   getLabelNumByDatasetId(data = {}) {
    return axios.post(api.getLabelNumByDatasetId, data);
  },
  /**
   * 修改数据集  @data  "datasetId"数据集id datasetContent数据集简介  datasetName数据集名称
   */
  updateDataset(data = {}) {
    return axios.post(api.updateDataset, data);
  },
  /**
   * 删除数据集  @data  "datasetId"数据集id datasetContent数据集简介  datasetName数据集名称
   */
  deleteDataset(data = {}) {
    return axios.post(api.deleteDataset, data);
  },
  /**
   * 发布数据集  @data  "datasetId"数据集id   datasetName数据集名称
   */
   releaseDataset(data = {}) {
    return axios.post(api.releaseDataset, data);  
  },
  /**
   * 复制数据集  @data  "datasetId"数据集id   type 类型
   */
   copyDataset(data = {}) {
    return axios.post(api.copyDataset, data);  
  },
  /**
   * 创建标签 分类标签  @data  "datasetId"数据集id labelName标签名称; labelColor:标签颜色
   */
  addLabel(data = {}) {
    return axios.post(api.addLabel, data);
  },
  /**
   *  编辑标签  @data  "datasetId"数据集id labelName标签名称 labelId 标签id
   */
  updateLabelBylabelId(data = {}) {
    return axios.post(api.updateLabelBylabelId, data);
  },
  /**
   *  删除标签 @data  "datasetId"数据集id labelName标签名称 labelId 标签id
   */
  deleteLabelBylabelId(data = {}) {
    return axios.post(api.deleteLabelBylabelId, data);
  },
  /**
   *  图像分类 根据标签id查询图片列表  @data   labelName标签名称 标签id  datasetId labelId pageNum  pageSize
   */
  getImgBylabelId(data) {
    return axios.post(api.getImgBylabelId, data);
  },
  /**
   * 根据数据集id和标签id查询图片列表  @data "datasetId"数据集id ,isTag为0未标注，1已标注，2全部
   */
  getImgByDatasetId(data = {}) {
    return axios.post(api.getImgByDatasetId, data);
  },
  /**
   * 物体检测 根据标签id查询图片列表   @data   labelName标签名称 标签id  datasetId labelId pageNum  pageSize
   */
  getImgByLabelIdList(data = {}) {
    return axios.post(api.getImgByLabelIdList, data);
  },
  /**
   * 批量上传图片
   */
  uploadImgBylabelId(data = {}) {
    return axios.post(api.uploadImgBylabelId, data);
  },
  /**
   * 修改图片名称 @data imgId图片id imgName图片名称
   */
  updateImgByImgId(data = {}) {
    return axios.post(api.updateImgByImgId, data);
  },
  /**
   * 删除图片 @data imgId图片id imgName图片名称
   */
  deleteImgByImgId(data = {}) {
    return axios.post(api.deleteImgByImgId, data);
  },
  /**
   * 修改图片是否符合条件状态 @data imgId图片id, isQualified图片是否符合条件：0为符合；1为不符合
   */
  updateImgIsQualifiedByImgId(data = {}) {
    return axios.post(api.updateImgIsQualifiedByImgId, data);
  },
  /**
   * 根据用户设置筛选图片 @data datasetId 数据集id, imgWidthMax 图片宽度最大值, imgWidthMin 图片宽度最小值, imgHeightMax 图片高度最大值, imgHeightMin 图片高度最小值, imgSizeMax 图片大小最大值, imgSizeMix 图片大小最小值
   */
  screenImg(data = {}) {
    return axios.post(api.screenImg, data);
  },


  /**
   * 新增训练模型 @data datasetId  labelIds labelNames modelId modelType
   */
  addTrainModel(data = {}) {
    return axios.post(api.addTrainModel, data);
  },
  /**
   * 选择模型版本下拉框 @data modelId
   */
  getModelVersion(data = {}) {
    return axios.post(api.getModelVersion, data);
  },
  /**
   * 查询训练模型下拉框 @data ？？？？？
   */
  getVerifyModel(data = {}) {
    return axios.post(api.getVerifyModel, data);
  },
  /**
   * 校验模型:图片分类、物体检测、文本分类、文本标注、音频分类
   * @data algorithmId校验模型id ，urls图片链接路径：['字符串']，modelType模型类型
   */
  verifyModel(data = {}) {
    return axios.post(api.verifyModel, data);
  },
  /**
   * 校验模型：音频标注 @data {
   *   "algorithmId": "校验模型id",
   *   "audioInfos": [0:[{"audioUrl":"音频路径", "startTime":"开始时间", "endTime":"结束时间"}],1:[]],
   *   "modelType": '模型类型'
   * }
   */
   verifyAudioTagModel(data = {}) {
    return axios.post(api.verifyAudioTagModel, data);
  },
  /**
   * 根据图片id查询图片标注数据 @data imgId 图片id labelId 标签id
   */
  getImgTagByImgId(data = {}) {
    return axios.post(api.getImgTagByImgId, data);
  },
  /**
   * 根据图片id标注图片 @data {
      "imgId": "string",
      "list": [
        {
          "imgId": "string",
          "labelId": "string",
          "x1": 0,
          "x2": 0,
          "y1": 0,
          "y2": 0
        }
      ]
    }
   */
  updateImgTagByImgId(data = {}) {
    return axios.post(api.updateImgTagByImgId, data);
  },
  /**
   * 发布训练模型 @data trainModelId 训练模型id
   */
  releaseModel(data = {}) {
    return axios.post(api.releaseModel, data);
  },
  /**
   * 修改模型公开状态 @data {trainModelId '训练模型id', isPublic: 0,(是否公开模型：0为否；1为是)}
   */
   updateIsPublic(data = {}) {
    return axios.post(api.updateIsPublic, data);
  },


  // 文本分类、文本标注
  /**
   * 根据标签id查询文本分类列表 @data trainingId：实训id；trainingName：实训名称； curriculumId 课程id； pageNum：1， pageSize：10，sort：0：创建时间；1：更新时间；2：项目名称；3：标签；sortRule：排序规则：0：升序；1：降序；
   */
  getTextByLabelId(data = {}) {
    return axios.post(api.getTextByLabelId, data);
  },

  /**
   * 批量上传文本 
   * @data "datasetId": "string", 数据集id
           "datasetTextList": [
             {
               "textName": "string", 文本名称
               "textUrl": "string", 文本路径
             }
           ],
           "labelId": "string" 标签id
   */
  uploadTextByLabelId(data = {}) {
    return axios.post(api.uploadTextByLabelId, data);
  },

  /**
   * 修改文本名称 @data textId：文本id；textName：文本名称；
   */
  updateTextByTextId(data = {}) {
    return axios.post(api.updateTextByTextId, data);
  },

  /**
   * 删除文本 @data textId：文本id；textName：文本名称；
   */
  deleteTextByTextId(data = {}) {
    return axios.post(api.deleteTextByTextId, data);
  },

  /**
   * 根据数据集id查询文本列表-文本标注 @data 
   {
     "datasetId": "string", 数据集id
     "pageNum": 1,
     "pageSize": 10,
     "isTag": 0, 是否标注：0 未标注；1 已标注；2 全部
   */
  getTextByDatasetId(data = {}) {
    return axios.post(api.getTextByDatasetId, data);
  },

  /**
   * 根据标签id查询文本列表-文本标注 @data 
   {
     "datasetId": "string", 数据集id
     "pageNum": 1,
     "pageSize": 10,
     "labelIdList": 0, 标签id集合
   */
  getTextByLabelIdList(data = {}) {
    return axios.post(api.getTextByLabelIdList, data);
  },

  /**
   * 根据文本id标注文本-文本标注 @data 
   {
     "list": [ 文本标注数据集合
       {
         "labelId": "string", 标签id
         "tagHeight": 0, 标注高度
         "tagValue": "string", 标注内容
         "textId": "string" 文本id
       }
     ],
     "textId": "string"  文本id
   }
   */
  updateTextTagByTextId(data = {}) {
    return axios.post(api.updateTextTagByTextId, data);
  },

  /**
   * 根据文本id查询文本标注数据-文本标注 @data textId：文本id
   */
  getTextTagByTextId(data = {}) {
    return axios.post(api.getTextTagByTextId, data);
  },

  /**
   * 根据标签id查询文本标注数据-文本标注 @data labelId：标注id；tagValue：标注名称（需要进行模糊搜索则传）；
   */
  getTextTagByLabelId(data = {}) {
    return axios.post(api.getTextTagByLabelId, data);
  },


  /**
   * 根据标签id查询标注数量 @data {
      "datasetId": "string", //数据集id
      "datasetType": 0, //数据集类型（同模型类型：modelType）
      "isQualified": 0, 条件筛选 0：全部；1:符合条件；2:不符合条件
      "labelIdList": [ // 标签id集合
        "string"
      ]
    }；
   */
  getTagNumByLabelIds(data = {}) {
    return axios.post(api.getTagNumByLabelIds, data);
  },


  // 音频分类、音频标注
  /**
   * 音频分类:根据音频id查询音频列表 @data {"pageNum": 1,"pageSize": 10,"labelId": "标签id"}
   */
  getAudioByLabelId(data = {}) {
    return axios.post(api.getAudioByLabelId, data);
  },

  /**
   * 音频标注:根据数据集id查询音频列表 @data {"pageNum": 1,"pageSize": 10,"datasetId": "数据集id","isTag":2,}
   */
  getAudioByDatasetId(data = {}) {
    return axios.post(api.getAudioByDatasetId, data);
  },
  /**
   * 音频标注:根据标签id查询音频列表 @data {"pageNum": 1,"pageSize": 7,"datasetId": "数据集id","labelIdList":['标签ids']}
   */
  getAudioByLabelIdList(data = {}) {
    return axios.post(api.getAudioByLabelIdList, data);
  },
  /**
   * 音频标注:根据音频id标注音频 @data {
      "audioId":"string",  // 音频id
      "list":[
        {
          "audioId":"", // 音频id
          "labelId":"", // 标签id
          "startTime":"", // 开始时间
          "endTime":"" // 结束时间
        }
      ],
      "tenantId":"string" // 租户id
    }
   */
  updateAudioTagByAudioId(data = {}) {
    return axios.post(api.updateAudioTagByAudioId, data);
  },
  /**
   * 音频标注:根据音频id查询音频标注数据 @data {
      "audioId": "string", // 音频id
      "labelIds": ["string"], // 标签ids
    }
   */
  getAudioTagByAudioId(data = {}) {
    return axios.post(api.getAudioTagByAudioId, data);
  },

  /**
   * 修改音频名称 @data { "audioId": "音频id", "audioName": "音频名称" }
   */
  updateAudioByAudioId(data = {}) {
    return axios.post(api.updateAudioByAudioId, data);
  },
  /**
   * 删除音频 @data { "audioId": "音频id" }
   */
   deleteAudioByAudioId(data = {}) {
    return axios.post(api.deleteAudioByAudioId, data);
  },
  /**
   * 批量上传音频 @data {
      "datasetAudioList": [
        {
          "audioName": "string", // 音频名称
          "audioUrl": "string", // 音频路径
        }
      ],
      "datasetId": "string", // 数据集id
      "labelId": "string", // 标签id
      "tenantId": 0 // 租户id
    }
   */
  uploadAudio(data = {}) {
    return axios.post(api.uploadAudio, data);
  },

  // 模型训练-训练配置
  /**
   * 查询模型版本配置下拉框  @data {
   *   modelId: 'String', // 模型id
   *   datasetId: 'String', // 数据集id
   *   labelIds: 'String', // 标签ids
   * }
   */
  getModelConfigSelect(data = {}) {
    return axios.post(api.getModelConfigSelect, data);
  },
  /**
   * 根据模型版本查看配置信息  @data {id: 'String'}
   */
  getConfigByModelVersion(data = {}) {
    return axios.post(api.getConfigByModelVersion, data);
  },
  /**
   * 查询增量学习下拉框  @data {
   *   modelId: 'String', // 模型id
   *   datasetId: 'String', // 数据集id
   *   labelIds: 'String', // 标签ids
   * }
   */
  getIncrementalLearningSelect(data = {}) {
    return axios.post(api.getIncrementalLearningSelect, data);
  },
  /**
   * 查询验证集列表  @data {
   *   labelNames: 'String', // 标签名称集
   *   tenantId: 'String', // 租户id
   *   type: 'String', // 类型：1为图像分类;2为物体检测;3为文本分类;4为文本标注;5为音频分类；6为音频标注
   * }
   */
   getValidationSetList(data = {}) {
    return axios.post(api.getValidationSetList, data);
  },
  /**
   * 查询测试集列表  @data {
   *   labelNames: 'String', // 标签名称集
   *   tenantId: 'String', // 租户id
   *   type: 'String', // 类型：1为图像分类;2为物体检测;3为文本分类;4为文本标注;5为音频分类；6为音频标注
   * }
   */
   getTestSetList(data = {}) {
    return axios.post(api.getTestSetList, data);
  },

};
